import React, { useState } from 'react';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { inviteExternalUser } from '../../../../services/UsersServices';

const InviteExternalUser = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contract, setContract] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [subcontractNumber, setSubcontractNumber] = useState('');
  const [pocName, setPocName] = useState('');
  const [pocEmail, setPocEmail] = useState('');
  const [pocPhone, setPocPhone] = useState('NA');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await inviteExternalUser({
        email,
        firstName,
        lastName,
        contract,
        companyName,
        subcontractNumber,
        pocName: pocName || `${firstName} ${lastName}`.trim() || email,
        pocEmail: pocEmail || email,
        pocPhone: pocPhone || 'NA',
      });
      const tempPassword = res?.tempPassword;
      const delivery = res?.delivery;
      const smtpMissing = res?.smtpMissing;
      const reinvited = !!res?.reinvited;
      await Swal.fire({
        icon: 'success',
        title: reinvited ? 'External user re-invited' : 'External user invited',
        text:
          delivery === 'sent'
            ? 'Temporary password email was sent.'
            : delivery === 'smtp_not_configured'
              ? `User was created, but email was not sent. Missing SMTP env: ${(
                  smtpMissing || []
                ).join(', ')}`
              : 'User was created, but email was not sent.',
        width: 520,
        confirmButtonColor: '#3a7afe',
      });
      if (tempPassword) {
        await Swal.fire({
          icon: 'info',
          title: 'Temporary password',
          text: tempPassword,
          width: 520,
          confirmButtonColor: '#3a7afe',
        });
      }
      navigate('/settings/users');
    } catch (err) {
      const status = err?.response?.status;
      const apiMsg = err?.response?.data?.data;
      if (status === 409 && String(apiMsg || '').toLowerCase().includes('user already exists')) {
        setError('User already exists and is already active.');
      } else {
        setError(apiMsg || 'Invite failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={submit}>
      <h2>Invite External User</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => {
                const value = e.target.value;
                setEmail(value);
                setPocEmail(value);
              }}
              required
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="firstName">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              value={firstName}
              onChange={(e) => {
                const value = e.target.value;
                setFirstName(value);
                if (!pocName) setPocName(`${value} ${lastName}`.trim());
              }}
              required
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="lastName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              value={lastName}
              onChange={(e) => {
                const value = e.target.value;
                setLastName(value);
                if (!pocName) setPocName(`${firstName} ${value}`.trim());
              }}
              required
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="contract">
            <Form.Label>Program / Contract</Form.Label>
            <Form.Control
              type="text"
              value={contract}
              onChange={(e) => setContract(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="companyName">
            <Form.Label>Company Name</Form.Label>
            <Form.Control
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="subcontractNumber">
            <Form.Label>Subcontract Number</Form.Label>
            <Form.Control
              type="text"
              value={subcontractNumber}
              onChange={(e) => setSubcontractNumber(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="pocName">
            <Form.Label>POC Name</Form.Label>
            <Form.Control
              type="text"
              value={pocName}
              onChange={(e) => setPocName(e.target.value)}
              placeholder="Defaults to user name"
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="pocEmail">
            <Form.Label>POC Email</Form.Label>
            <Form.Control type="email" value={pocEmail} readOnly />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="pocPhone">
            <Form.Label>POC Phone</Form.Label>
            <Form.Control
              type="text"
              value={pocPhone}
              onChange={(e) => setPocPhone(e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Button type="submit" disabled={loading}>
        Send Temporary Password
      </Button>
    </Form>
  );
};

export default InviteExternalUser;
